import React, {useEffect, useState, useCallback} from 'react'
import {useTranslation} from 'react-i18next'
import PropTypes from 'prop-types'

import DropZone from '../../dropzone'
import { FilesSimple } from './files'
import { asset } from '../../../redux/reducers/settings'
import * as my from './MyForm'
import {IconTrash} from "../../icons";
import {ModalConfirmDelete} from "../../modals";

const VideoPreview = ({video, onRemove, css, className = ''}) => {
	const {t} = useTranslation();
	const src = asset(typeof video === 'object' ? video.preview : video);
	const [deleteModal, updateDeleteModal] = useState({isShow: false, itemId: false});

	const openModalConfirmDelete = () => updateDeleteModal((prevState) => ({ ...prevState, isShow: true}))
	const closeModalConfirmDelete = () => updateDeleteModal((prevState) => ({ ...prevState, isShow: false}))
	const doRemove = (event) => {
		event.preventDefault()
		onRemove && onRemove()
		closeModalConfirmDelete()
	}

	const onRemoveBtnClick = (event) => {
		event.preventDefault()
		openModalConfirmDelete()
	}
	//console.log('VideoPreview: ', {video});
	return (
		<my.VideoBox>
			<my.VideoPreview
				autoPlay
				preload="auto"
				muted
				loop
				className={`w-${css?.w || 'full'} h-${css?.h || 40} ${className}`}
			>
				<source src={src} type="video/mp4" />
			</my.VideoPreview>

			<my.VideoRemoveButton onClick={onRemoveBtnClick} width={css?.w || 32}
				// className={`btn btn-sm btn-icon bg-transparent rounded-b hover:bg-blue-50 text-blue-500 hover:text-blue-600 w-${css?.w || 32}`}
			>
				<IconTrash size={20}/>
				<span>{t('general.button.remove')}</span>
			</my.VideoRemoveButton>

			<ModalConfirmDelete
				isOpen={deleteModal.isShow}
				itemIds={deleteModal.itemId}
				onCancel={closeModalConfirmDelete}
				onConfirm={doRemove}
				description={t('modal.confirmdelete.description_video')}
			/>
		</my.VideoBox>
	)
}

const ImagePreview = ({image, onRemove, css, className = ''}) => {
	const {t} = useTranslation();
	const src = asset(typeof image === 'object' ? image.preview : image);
	const [deleteModal, updateDeleteModal] = useState({isShow: false, itemId: false});

	const openModalConfirmDelete = () => updateDeleteModal((prevState) => ({ ...prevState, isShow: true}))
	const closeModalConfirmDelete = () => updateDeleteModal((prevState) => ({ ...prevState, isShow: false}))
	const doRemove = (event) => {
		event.preventDefault()
		onRemove && onRemove()
		closeModalConfirmDelete()
	}

	const onRemoveBtnClick = (event) => {
		event.preventDefault()
		openModalConfirmDelete()
	}
	//console.log('ImagePreview: ', {image});
	return <>
		<my.ImageBox>
			<my.ImagePreview
				src={src}
				alt="thumbnail"
				className={`w-${css?.w || 'full'} h-${css?.h || 40} ${className}`}
			/>

			<my.ImageRemoveButton onClick={onRemoveBtnClick} width={css?.w || 32}
				// className={`btn btn-sm btn-icon bg-transparent rounded-b hover:bg-blue-50 text-blue-500 hover:text-blue-600 w-${css?.w || 32}`}
			>
				<IconTrash size={20}/>
				<span>{t('general.button.remove')}</span>
			</my.ImageRemoveButton>

			<ModalConfirmDelete
				isOpen={deleteModal.isShow}
				itemIds={deleteModal.itemId}
				onCancel={closeModalConfirmDelete}
				onConfirm={doRemove}
				description={t('modal.confirmdelete.description_image')}
			/>
		</my.ImageBox>
	</>
}

const MediaPreview = ({media, onRemove, css, className = ''}) => {
	let src = typeof media === 'object' ? media.name : media;

	return src.includes('.mp4') ?
		<VideoPreview video={media} onRemove={onRemove} css={css} className={className} />
			: <ImagePreview image={media} onRemove={onRemove} css={css} className={className} />
}

export const Image = ({
	inline = false,
	padding = true,
	label = '',
	defaultValue = false,
	hint = '',
	errorMessage = '',
	validMessage = '',
	dropMessage,
	onRemove = false,
	onDrop = false,
	className,
	hiddenElement = false,
	css,
	...rest
}) => {
	const {t} = useTranslation();
	const [image, setImage] = useState(defaultValue)

	const doRemove = useCallback((rest) => () => {
		setImage(false)
		onRemove && onRemove(rest.name)
		// rest.name && reset({ [rest.name]: new File() });
	}, [onRemove])

	const doDrop = useCallback((files) => {
		console.log('acceptedFiles', files)
		if(!files || files.length === 0) {
			return
		}
		Object.assign(files[0], { preview: URL.createObjectURL(files[0]) })
		setImage(files[0])
		onDrop && onDrop(files[0])
	}, [onDrop])

	useEffect(() => setImage(defaultValue), [defaultValue])

	// useEffect(
	//     () => {
	//         // Make sure to revoke the data uris to avoid memory leaks
	//         image && typeof image === 'object' &&  URL.revokeObjectURL(image.preview)
	//     },
	//     [image]
	// )

	// let color = 'blue';
	return (
		<my.Elemet data-inline={!!inline} data-padding={!!padding} data-hidden={!!hiddenElement}>
			{!!label && <my.Label data-inline={!!inline}>{label}</my.Label>}
			{
				image
					? (
						<MediaPreview
							media={image}
							onRemove={doRemove(rest)}
							css={css}
							className={className}
						/>
					)
					: (
						<DropZone
							{...rest}
							options={{
								accept: rest.accept || 'image/*',
								maxSize: 5 * 1024 * 1024, //5mb
								maxFiles: 1,
								multiple: false,
								onDrop: doDrop,
							}}
							dropMessage={dropMessage || t('form.field.image_drop_message')}
							size={{w: css?.w || 40, h: css?.h || 40}}
						/>
					)
			}
			{!!errorMessage && (<my.Error data-inline={!!inline} data-white-space="normal">{errorMessage}</my.Error>)}
			{!!validMessage && (<my.Success data-inline={!!inline} data-white-space="normal">{validMessage}</my.Success>)}
			{
				!!hint && (
					typeof hint === 'string' 
						? <my.Hint data-inline={!!inline} data-white-space="normal" dangerouslySetInnerHTML={{__html: hint}} />
						: <my.Hint data-inline={!!inline} data-white-space="normal">{hint}</my.Hint>
				)
			}
		</my.Elemet>
	)
}
Image.propTypes = {
	inline: PropTypes.bool,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	name: PropTypes.string,
	hint: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	errorMessage: PropTypes.string,
	validMessage: PropTypes.string
}

const ImagesPreview = ({files, onRemove}) => {
	if(!files || files.length <= 0) return null;

	return (
		<>
			{files.map((media, idx)=>{
				return (
					<MediaPreview key={idx} media={media} onRemove={()=>onRemove(idx)} />
				)
			})}
		</>
	)
}

export const Images = ({
	defaultValue,
	onChange,
	accept= 'image/*',
	...rest
}) => {
	const {t} = useTranslation();
	const [images, setImages] = useState(defaultValue)

	const onChangeImages = useCallback((files) => {
			typeof onChange === 'function' && onChange(files);
			setImages(files)
		},
		[]
	)
	const onRemoveImage = useCallback((fieldName) => {
			typeof onChange === 'function' && onChange(null);
			setImages(null);
		},
		[images]
	)

	return (
		<>
			<FilesSimple dropMessage={t('form.field.image_drop_message')}
				   {...rest}
				   maxFiles={10}
				   maxSizeMb={5}
				   accept={accept}
				   filesPreview={<ImagesPreview />}
				   defaultValue={images}
				   css={{h:20}}
				   onRemove={onRemoveImage}
				   onDrop={onChangeImages}
			/>
		</>
	);
}
